import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getServices = () =>
  axiosInstance.get(`${LANDING_API_URL}/services`, {
    headers: authHeaders(),
  });

export const createServiceRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/services`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateServiceRequest = (id, formData) =>
  axiosInstance.post(`${LANDING_API_URL}/services/${id}`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const removeService = (serviceId) =>
  axiosInstance.delete(`${LANDING_API_URL}/services/${serviceId}`, {
    headers: authHeaders(),
  });
